import(/* webpackMode: "eager", webpackExports: ["MissionPage"] */ "/app/src/modules/promotions/mission/components/MissionPage/index.tsx");
